import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import MultipleViewsToggle from 'nav/sidepanel/listing/MultipleViewsToggle';
import {PAIRWISE_ALIGNMENT_ZOOM_THRESHOLD} from 'search/blast/BLASTAlignmentUtil';
import {BlastColorLegend} from 'search/blast/BlastColorLegend';
import MultiquerySelector from 'search/blast/MultiquerySelector';
import {Operator} from 'search/SearchConstants';

import {SearchView} from './search-results/SearchResultsView';

interface SecondHeaderRowProps {
  viewSelection: SearchView;
  setViewSelection: (view: SearchView) => void;
  zoom: number;
  isMultiquery: boolean;
  groupBySelection?: string;
  setGroupBySelection: (selection: string) => void;
  groupIds: Array<string>;
  blastOperator: Operator;
}
export default function SecondHeaderRow(props: SecondHeaderRowProps): JSX.Element {
  return (
    <div className={css(styles.topDiv)}>
      <div className={css(styles.leftWrapper)}>
        {props.isMultiquery && (
          <MultiquerySelector
            groupBySelection={props.groupBySelection}
            setGroupBySelection={props.setGroupBySelection}
            groupIds={props.groupIds}
          />
        )}
        <MultipleViewsToggle
          viewSelection={props.viewSelection}
          setViewSelection={props.setViewSelection}
          blastOperator={props.blastOperator}
        />
      </div>
      {props.zoom < PAIRWISE_ALIGNMENT_ZOOM_THRESHOLD && props.viewSelection === SearchView.ALIGNMENT && (
        <BlastColorLegend />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  topDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '10px',
  },
  leftWrapper: {
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-end',
  },
});
